import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import axiosInstance from "services/AxiosInstance";
import { useNavigate } from "react-router-dom";
import { SpinnerCitoPlus } from "jsx/components/CitoPlus/components/loadingLogo";

const URL = "/api/v3/zonas-sociales/activos/dashboard/metricas/";

const ActivosDashboard = () => {
  const navigate = useNavigate();
  const [metrics, setMetrics] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(URL);
        setMetrics(response.data);
      } catch (error) {
        console.error("Error fetching metrics:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  if (isLoading) {
    return (
      <div className="col-xl-12 mb-4">
        <div className="card">
          <div className="card-body text-center py-5">
            <SpinnerCitoPlus text="Cargando métricas de activos..." />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="card-body">
        <div className="row shapreter-row">
          <div
            className="col-xl-3 col-lg-3 col-sm-6 col-6"
            onClick={() => navigate("/activos")}
            style={{ cursor: "pointer" }}
          >
            <div className="static-icon">
              <span>
                <i className="fas fa-boxes-stacked"></i>
              </span>
              <h3 className="count mb-0">
                <CountUp end={metrics?.total_activos || 0} duration={2} />
              </h3>
              <span className="fs-14">Total Activos</span>
            </div>
          </div>
          <div
            className="col-xl-3 col-lg-3 col-sm-6 col-6"
            onClick={() => navigate("/activos/mantenimientos")}
            style={{ cursor: "pointer" }}
          >
            <div className="static-icon">
              <span>
                <i className="fas fa-tools"></i>
              </span>
              <h3 className="count mb-0">
                <CountUp end={metrics?.activos_en_mantenimiento || 0} duration={2} />
              </h3>
              <span className="fs-14">En Mantenimiento</span>
            </div>
          </div>
          <div
            className="col-xl-3 col-lg-3 col-sm-6 col-6"
            onClick={() => navigate("/activos/calendario")}
            style={{ cursor: "pointer" }}
          >
            <div className="static-icon">
              <span>
                <i className="fas fa-calendar-check"></i>
              </span>
              <h3 className="count mb-0">
                <CountUp end={metrics?.mantenimientos_proximos_7d || 0} duration={3} />
              </h3>
              <span className="fs-14">Mant. Próximos</span>
            </div>
          </div>
          <div
            className="col-xl-3 col-lg-3 col-sm-6 col-6"
            onClick={() => navigate("/activos")}
            style={{ cursor: "pointer" }}
          >
            <div className="static-icon">
              <span>
                <i className="fas fa-triangle-exclamation"></i>
              </span>
              <h3 className="count mb-0">
                <CountUp end={metrics?.garantias_vencidas || 0} duration={2} />
              </h3>
              <span className="fs-14">Garantías Vencidas</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivosDashboard;
